export default __webpack_public_path__ + "static/media/dashboard.33a530fe.svg";